import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// const origin = process.env.REACT_APP_LOCALES_PATH;
const origin=process.env.REACT_APP_ENV === "dev"?process.env.REACT_APP_LOCALES_PATH: window.origin
const lngs = [
  "en",
  "en-SCHOOL",
  "hi",
  "hi-SCHOOL",
  "ml",
  "ml-SCHOOL",
  "kn",
  "kn-SCHOOL",
  "en-PU",
];
i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    debug: true,
    whitelist: lngs,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: origin + "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
